module.exports = __webpack_public_path__ + "img/20190812162456233.308f7e4c.png";